import React from 'react'

import UsersContainer from 'containers/Admin/Users'

const Users = () => (
  <div>
    <UsersContainer />
  </div>
)

export default Users



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Users/index.js